var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightPanel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 35 35",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 15.909,
    height: 35
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.091,
    y: 12.727,
    width: 15.909,
    height: 9.546
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.091,
    width: 15.909,
    height: 9.545
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.091,
    y: 25.455,
    width: 15.909,
    height: 9.545
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightPanel);
export default __webpack_public_path__ + "static/media/right-panel.38ba329e0bc2dff238c0e2a097d23571.svg";
export { ForwardRef as ReactComponent };